// Renders a Material Design Icon by the raw name the backend ships on meters
// (e.g. "mdi-fire", "mdi-water") via the @mdi/font webfont — the class name IS
// the backend string, so any of MDI's icons render with no per-icon mapping.
// The glyph takes its color from `currentColor` and its size from font-size, so
// it drops into the brand-colored `.icon-bubble` like the old inline SVGs did.

import type { CSSProperties, ReactElement } from 'react';

// Normalise a backend icon string to an `mdi-*` class. Accepts values with or
// without the prefix and the occasional `mdi:foo` colon form; blank/unknown
// falls back to a gauge (the old meter default was the speedometer).
export function mdiClass(name: string | null | undefined): string {
  const raw = (name ?? '').trim().replace(/^mdi[:-]/, '');
  return raw ? `mdi-${raw}` : 'mdi-gauge';
}

export default function MdiIcon({
  name,
  size = 20,
  className,
  style,
}: {
  name: string | null | undefined;
  size?: number;
  className?: string;
  style?: CSSProperties;
}): ReactElement {
  return (
    <span
      className={`mdi ${mdiClass(name)}${className ? ` ${className}` : ''}`}
      style={{ fontSize: size, lineHeight: 1, ...style }}
      aria-hidden="true"
    />
  );
}
